/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Plan_Change_Product_HyroxInputs */

const fr_membership_plan_change_product_hyrox = /** @type {(inputs: Membership_Plan_Change_Product_HyroxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyrox`)
};

/**

* @param {Membership_Plan_Change_Product_HyroxInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_product_hyrox = /** @type {((inputs?: Membership_Plan_Change_Product_HyroxInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_Product_HyroxInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_product_hyrox(inputs)
});